import { platformsService } from '@/services/platforms.service';
import axios from 'axios';

const initialState = () => ({
  platforms: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getPlatforms({ commit }) {
    commit('GET_PLATFORMS');
    return platformsService.getPlatforms().then(
      (platforms) => commit('GET_PLATFORMS_SUCCESS', platforms),
      (error) => {
        if (!axios.isCancel(error)) {
          commit('GET_PLATFORMS_ERROR', error);
        }
      },
    );
  },
  async updatePlatform({ commit, dispatch }, platform) {
    const saved = await platformsService.updatePlatform(platform);
    commit('UPDATE_PLATFORM_SUCCESS', saved);
    // The filter chip and details panel read names/descriptions from userPlatforms.
    dispatch('userPlatforms/getUserPlatforms', null, { root: true });
    return saved;
  },
  RESET(state) {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const mutations = {
  GET_PLATFORMS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.platforms = [];
  },
  GET_PLATFORMS_SUCCESS(state, platforms) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.platforms = platforms;
  },
  UPDATE_PLATFORM_SUCCESS(state, platform) {
    const index = state.platforms.findIndex((item) => item.id === platform.id);
    if (index !== -1) {
      state.platforms.splice(index, 1, platform);
    }
  },
  GET_PLATFORMS_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  platforms: (state) => state.platforms,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const platforms = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
